/* eslint-disable jira/filename-case */
import type { ModalDialogProps } from '@atlaskit/modal-dialog/types';

export const TARGET_RANK = '2.1';

export const BLUEPRINTS_SETTINGS_URL =
	'/jira/settings/products/jira-product-discovery/view-blueprints';

export const modalProps: Pick<ModalDialogProps, 'shouldCloseOnEscapePress' | 'width' | 'height'> = {
	shouldCloseOnEscapePress: true,
	width: 952,
	height: 568,
};
